import { DialogComponent } from '@theme/dialog';

/** 品牌图片沿用主题弹窗；脚本未加载时，链接仍可直接打开大图。 */
class BrandArtwork extends DialogComponent {
  /** @param {MouseEvent} event 点击图片的事件。 */
  showArtwork(event) {
    // 保留新标签打开和浏览器快捷键的默认行为。
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    this.showDialog();
  }
}

if (!customElements.get('brand-artwork')) {
  customElements.define('brand-artwork', BrandArtwork);
}
